import * as THREE from "three";
import {Mesh, MeshBasicMaterial} from "three";
import {NamedCube} from "../Game";

export class PickHelper {
    public raycaster: THREE.Raycaster;
    public picked_object: THREE.Mesh | null;
    public picked_object_saved_color: number;

    constructor() {
        this.raycaster = new THREE.Raycaster();
        this.picked_object = null;
        this.picked_object_saved_color = 0;
    }

    public pick(normalizedPosition: THREE.Vector2, cubes: NamedCube[], world: Mesh, camera: THREE.Camera, time: number) {
        // restore the color if there is a picked object
        // if (this.picked_object) {
        //     const material = this.picked_object.material;
        //     if (material instanceof MeshBasicMaterial) {
        //         material.color.setHex(this.picked_object_saved_color);
        //     }
        //     this.picked_object = null;
        // }

        // cast a ray through the frustum
        this.raycaster.setFromCamera(normalizedPosition, camera);
        // get the list of objects the ray intersected
        const intersectedObjects = this.raycaster.intersectObjects(
            [
                ...cubes.map((ncube)=>ncube.cube),
                world
            ]);
        if (intersectedObjects.length) {
            // pick the first object. It's the closest one
            const object = intersectedObjects[0].object;
            if (object instanceof Mesh) {
                this.picked_object = object;
                const material = this.picked_object.material;
                if (material instanceof MeshBasicMaterial) {
                    // save its color
                    // this.picked_object_saved_color = material.color.getHex();
                    // set its emissive color to flashing red/yellow

                    // material.color.setHex((time * 8) % 2 > 1 ? 0xFFFF00 : 0xFF0000);
                    window.alert('You has clicked ' + this.name_of_cube(cubes, object));
                }
            }
        }
    }

    public name_of_cube(cubes: NamedCube[], cube: Mesh): string |null{
        return cubes.reduce((name: string | null, next: NamedCube) => {
            if (name !== null) return name;
            if (next.cube === cube) return next.name;
            return null;
        }, null);
    }
}